export function rouletteConfirmLabel(
  template: string,
  betCount: number,
  amount: string,
  currency: string,
): string {
  return template
    .replace('%n%', String(betCount))
    .replace('%amount%', amount)
    .replace('%currency%', String(currency || '').trim().toUpperCase());
}
